define(
  'app/views/newsletter_finished_view',['app/setup', 'app/views/newsletter_view'],
  function(takhfifan, newsletterView) {

  takhfifan.NewsletterFinishedView = takhfifan.NewsletterView.extend({

    events: {
      'click .submit': 'submit',
      'click li': 'setCity'
    },

    initialize: function(options) {
      this.cookie_success = 'subscribed';

      this.model.on('submit:success', this.success, this);
      this.model.on('submit:invalid', this.renderErrors, this);
      this.model.on('newsletter:loading', this.loading, this);
      Backbone.Validation.bind(this);
      this.render();
    },

    render: function() {
      this.$el.show();
    },
    
    loading: function() {
      this.$('.submit').html('<span class="spinner"></span>');
    },

    success: function() {
      this.$('.error').empty().hide();
      this.$('form').hide();
      this.$('.success').show();
      this.$('.submit').empty().html('عضویت در خبرنامه');

      this.setCookie({
        name: this.cookie_success,
        expires: 28
      });
    }

  });
});

